module.exports = __webpack_public_path__ + "img/martin-horst-avatar.61d112d4.jpg";